<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="$router.push('/home')"></spot-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-else>
				<div class="results" v-if="showResults">
					<div class="package-title" v-if="tablesData.currentLocation">{{ labelPackage }} {{ tablesData.currentLocation.code }}</div>
					<div class="group-title">
						<ion-label v-if="receiptsFound.length > 0">{{ labelReceivingText }} ({{ receiptsFound.length }})</ion-label>
					</div>
					<ion-item v-for="element in receiptsFound" :key="element.id" :color="checkDisposable(element) ? 'medium' : 'light'">
						<ion-label>{{element.code}}</ion-label>
						<ion-icon v-if="element.closed" :icon="bagCheck" color="success"></ion-icon>
						<ion-icon v-if="element.disposed" :icon="trashBin" color="danger"></ion-icon>
						<spot-button fill="solid" size="default" color="primary" icon="logInOutline" :expand="null" :text="buttonOpenText" @clicked="openReceipt(element.id)">
						</spot-button>
					</ion-item>
					<div class="group-title">
						<ion-label v-if="shipmentsFound.length > 0">{{ labelShippingText }} ({{ shipmentsFound.length }})</ion-label>
					</div>
					<ion-item v-for="element in shipmentsFound" :key="element.id" :color="checkDisposable(element) ? 'medium' : 'light'">
						<ion-label>{{element.code}}</ion-label>
						<ion-icon v-if="element.closed" :icon="bagCheck" color="success"></ion-icon>
						<ion-icon v-if="element.disposed" :icon="trashBin" color="danger"></ion-icon>
						<spot-button fill="solid" size="default" color="primary" icon="logOutOutline" :expand="null" :text="buttonOpenText" @clicked="openShipment(element.id)">
						</spot-button>
					</ion-item>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style scoped>
	ion-label {
		font-weight:bold;
	}
	.results {
		margin-top: .5em;
	}
	ion-item {
		margin-left: .5em;
		margin-right: .5em;
	}
	.package-title {
		font-weight: bold;
		text-align: center;
	}
	.group-title {
		font-weight: bold;
		margin-left: 3em;
		margin-top: 1em;
	}
</style>

<script>
	import { IonContent, IonIcon, IonItem, IonLabel, IonPage, IonSpinner } from "@ionic/vue";
	import { bagCheck, logInOutline, logOutOutline, trashBin } from "ionicons/icons";
	import { defineComponent } from "vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import { settings } from "../plugins/settings.js";
	import { getLocation, getPastDate, jsonSearchProjectRows, tablesData } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "RevisionLocation",
		props: {
			pageTitle: { type: String, default: "Cerca oggetti in Ubicazione" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingLocationText: { type: String, default: "Caricamento Ubicazione..." },
			loadingSearchedItemsText: { type: String, default: "Caricamento Risultati..." },
			buttonOpenText: { type: String, default: "Apri" },
			labelReceivingText: { type: String, default: "RICEZIONI" },
			labelShippingText: { type: String, default: "SPEDIZIONI" },
			labelfinalize: { type: String, default: "Procedi" },
			messageTitle: { type: String, default: "RICERCA RICEZIONI/SPEDIZIONI" },
			labelPackage: { type: String, default: "Oggetti in:" },
			errorSearchMessage: { type: String, default: "Errore durante la ricerca" },
		},
		components: {
			IonPage,
			IonContent,
			IonSpinner,
			IonItem,
			IonLabel,
			IonIcon,
			SpotHeader,
			SpotButton,
		},
		data: () => ({
			isActive: null,
			showResults: false,
			locationId: null,
			disposableDate: null,
			spinnerText: null,
			logInOutline,
			logOutOutline,
			bagCheck,
			trashBin,
			settings,
			getLocation,
			getPastDate,
			jsonSearchProjectRows,
			tablesData,
		}),
		computed: {
			receiptsFound() {
				//TODO:forse meglio questo return this.tablesData.project.project_rows_count
				return this.tablesData.projectRows.filter(function (projectRow) {
					return (projectRow.project.receiving == true)
				})
			},
			shipmentsFound() {
				//TODO:forse meglio questo return this.project.project_rows_count
				return this.tablesData.projectRows.filter(function (projectRow) {
					return (projectRow.project.shipping == true)
				})
			},
			allOpenedProjectRows() {
				return {
					q: {
						'location_id_eq': parseInt(this.locationId),
						'closed_eq': false, //to show only not closed
					}
				}
			},
		},
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			await this.setDefault();
			// await this.getAllTablesData();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			async getUrlParamsAndQuery() {
				if (this.$route.params.id) {
					this.locationId = this.$route.params.id;
				}
				else {
					this.locationId = null;
				}
			},
			//Database
			async getAllTablesData() {
				if (this.locationId) {
					this.spinnerText = this.loadingLocationText;
					await this.getLocation(this.locationId);
					await this.searchRecords(this.allOpenedProjectRows);
				}
			},
			checkDisposable(elementToCheck) {
				return (elementToCheck.closed == false && elementToCheck.disposed == false && elementToCheck.created_at < this.disposableDate);
			},
			async searchRecords(currSearch) {
				this.spinnerText = this.loadingSearchedItemsText;
				this.tablesData.projectRows = [];
				await this.jsonSearchProjectRows(currSearch);
				if (this.tablesData.projectRows) {
					this.showResults = true;
				}
			},
			//Actions
			openReceipt(movementId) {
				this.$router.push(`/finalize/receipt/` + movementId);
			},
			openShipment(movementId) {
				this.$router.push(`/finalize/shipment/` + movementId);
			},
			async setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				if (this.locationId) this.showResults=true; else this.showResults=false;
				this.disposableDate = await getPastDate(this.settings.global.disposeWaitingDays);
			},
		},
	});
</script>